import { MenuSection, ShowcaseBanner } from "../../components";
import Gallery from "../../components/Gallery";
import HomePreviewSections from "../../components/Sections/HomeSections";
import { DecorativeElement } from "../../components/Decorative";

const Home = () => {
  return (
    <div className="flex w-full h-auto flex-col items-center justify-center">
      <ShowcaseBanner />
      <MenuSection />
      <DecorativeElement type="divider" className="w-full max-w-7xl mx-auto" />
      <HomePreviewSections />
      <Gallery />
      <DecorativeElement type="divider" className="w-full max-w-7xl mx-auto" />
    </div>
  );
};

export default Home;
